export default __webpack_public_path__ + "static/media/upload.632f4bbe.png";